<template>
  <el-dialog class="detail"
             :visible.sync="detailVisible"
             :close-on-click-modal="false"
             @closed="detailCloseDialog"
             width="80%"
             @open="openCb"
             title="考勤详情"
             :loading="loading">

    <div class="detailSearchCont">
      <el-form :model="searchForm"
               ref="searchForm"
               label-width
               :inline="true">
        <el-form-item label="员工姓名">
          <el-input placeholder="请输入员工姓名"
                    maxlength="10"
                    size="small"
                    v-model="searchForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status"
                     size="small"
                     placeholder="请选择状态">
            <el-option v-for="item in statusList"
                       :key="item.status"
                       :label="item.name"
                       :value="item.status"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="getDetail">
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-folder-add"
                     size="small"
                     @click="allExport">
            批量导出报告
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="detailTable">
      <el-table border
                :data="tableData"
                ref="tableData"
                v-loading="loading"
                highlight-current-row
                height='400'>
        <el-table-column label="姓名"
                         align="center"
                         property="name"
                         fixed>
        </el-table-column>
        <el-table-column label="工号"
                         property="job_no"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label="部门"
                         property="depart"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label="日期"
                         property="sign_date"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label="星期"
                         property="week"
                         align="center">
        </el-table-column>
        <el-table-column label="上班时间"
                         property="sign_in"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.sign_in?scope.row.sign_in:'--'}}
          </template>
        </el-table-column>
        <el-table-column label="下班时间"
                         property="sign_out"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.sign_out?scope.row.sign_out:'--'}}
          </template>
        </el-table-column>
        <el-table-column label="上班确认"
                         property="resign_in"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.resign_in?scope.row.resign_in:'--'}}
          </template>
        </el-table-column>
        <el-table-column label="下班确认"
                         property="resign_out"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.resign_out?scope.row.resign_out:'--'}}
          </template>
        </el-table-column>
        <el-table-column label="审核状态"
                         property="check_status"
                         align="center">
          <template slot-scope="scope">
            <div :class="scope.row.check_status=='未审核'?'redText':''">
              {{scope.row.check_status?scope.row.check_status:'--'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="迟到分钟"
                         property="late_minute"
                         align="center">
        </el-table-column>
        <el-table-column label="早退分钟"
                         property="early_minute"
                         align="center">
        </el-table-column>
        <el-table-column label="加班小时"
                         property="over_hour"
                         align="center">
        </el-table-column>
        <el-table-column label="状态"
                         property="status_cn"
                         align="center">
          <template slot-scope="scope">
            <div :class="scope.row.status==2?'redText':''">
              {{scope.row.status_cn}}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <pagination :total="total"
                  :page.sync="page"
                  :perPage.sync="perPage"></pagination>
    </span>
  </el-dialog>
</template>
<script>
import pagination from "@/comon/components/pagination"
import * as oaApi from "@/http/oaApi.js";
export default {
  data () {
    return {
      loading: false,
      page: 1,
      perPage: 10,
      total: '',
      tableItem: '',
      statusList: [
        { name: '请选择', status: '' },
        { name: '正常', status: 1 },
        { name: '异常', status: 2 }
      ],
      searchForm: {
        name: '',
        status: ''
      }
    }
  },
  computed: {
    mixed () {
      const { tableItem, detailVisible } = this
      return {
        tableItem, detailVisible
      }
    }
  },
  methods: {
    detailCloseDialog () {
      this.tableItem = ''
      this.searchForm = {
        name: '',
        status: ''
      }
      this.page = 1
      this.perPage = 10
      this.$emit('update:detailVisible', false)
    },
    getDetail () {
      oaApi.attendanceDetail({
        year: this.tableItem.year,
        month: this.tableItem.month,
        name: this.searchForm.name,
        status: this.searchForm.status,
        'per-page': this.perPage,
        page: this.page
      }, 'get').then(res => {
        if (res) {
          this.tableData = res.data
          this.total = res.total
          this.$refs.tableData.bodyWrapper.scrollTop = 0;
        }
      })
    },
    allExport () {
      oaApi.attendanceDetailExport({
        year: this.tableItem.year,
        month: this.tableItem.month
      }, 'get').then(res => {
        if (res) {
          window.open(res.data.url)
        }
      })
    }
  },
  watch: {
    mixed: {
      handler (newValue) {
        this.tableItem = newValue.tableItem
        if (newValue.detailVisible) {
          this.getDetail()
        }
      },
      deep: true,
      immediate: false
    },
    perPage: {
      handler (newValue) {
        this.perPage = newValue;
        this.getDetail()
      },
      deep: true,
      immediate: false
    },
    page: {
      handler (newValue) {
        this.page = newValue;
        this.getDetail()
      },
      deep: true,
      immediate: false
    }
  },
  props: {
    detailVisible: 'Boolean',
    tableItem: 'Object'
  },
  components: {
    pagination: pagination
  }
}
</script>
<style lang="scss">
.detail {
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
    .el-dialog__body {
        padding: 10px 20px !important;
    }
    .detailSearchCont {
        display: flex;
        width: 100%;
        // padding: 0 20px;
        box-sizing: border-box;
        align-items: center;
    }
    .detailTable {
        height: 100%;
        .redText {
            color: red;
        }
    }
}
</style>